
import SidebarLeft from "../../../assets/filled/SidebarLeft.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SidebarLeftIcon({ className, dataTestid = "SidebarLeftIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SidebarLeft data-testid={dataTestid} className={classes} {...rest} />
  );
}
